import script from "./ProjectAuditTrail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectAuditTrail.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectAuditTrail.vue?vue&type=style&index=0&id=8c267aa0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c267aa0"]])

export default __exports__